'use client';

import React, { useEffect } from 'react';
import Script from 'next/script';
import { useCookiesConsent } from '../../providers';

interface Props {
  clarityId: string;
}

export const MicrosoftClarity: React.FC<Props> = ({
  clarityId,
}) => {
  const { cookiesConsented } = useCookiesConsent();

  useEffect(() => {
    if (cookiesConsented === true && (window as any).clarity) {
      (window as any).clarity('consent');
    }
  }, [cookiesConsented]);

  return (
    <React.Fragment>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
              if(${cookiesConsented} === true) {
                c[a]('consent');
              }
            })(window, document, 'clarity', 'script', '${clarityId}');
          `,
        }}
      />
    </React.Fragment>
  )
}

export const sendClarityEvent = (eventName: string, eventProperties: object) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).clarity('event', eventName, eventProperties);
};
